module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_eyeheight.c1b93861.jpg";